import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom'
import 'bootstrap/dist/css/bootstrap.min.css';
import './index.css';
import Header from './components/Header';
import HeaderDefault from './components/HeaderDefault';
import Footer from './components/Footer';
import Home from './pages/Home';
import DeclarationAccessibilite from './pages/DeclarationAccessibilite';
import MentionsLegales from './pages/MentionsLegales';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Router>
      <Routes>
        <Route path="/" element={<Header />} />
        <Route path="/mentions-legales" element={<HeaderDefault />} />
        <Route path="/declaration-accessibilite" element={<HeaderDefault />} />
      </Routes>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/declaration-accessibilite" element={<DeclarationAccessibilite />} />
        <Route path="/mentions-legales" element={<MentionsLegales />} />
      </Routes>
      <Footer/>
    </Router>
  </React.StrictMode>,
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();